import { render } from "./listUsers_page.vue?vue&type=template&id=6788b3fd&scoped=true"
import script from "./listUsers_page.vue?vue&type=script&lang=js"
export * from "./listUsers_page.vue?vue&type=script&lang=js"

import "./listUsers_page.vue?vue&type=style&index=0&id=6788b3fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6788b3fd"]])

export default __exports__